import React from 'react';
import './index.scss';

const SectionBanner: React.FC = props => {
  return <div className="section-banner">
      <span>{props.children}</span>
  </div>;
}

export default SectionBanner;